module.exports = __webpack_public_path__ + "static/img/6c820ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/openAccount/images/ios.png
// module id = 662
// module chunks = 2